var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfirmTicked = function SvgConfirmTicked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00AC75",
    d: "M34 67.308c18.502 0 33.5-14.999 33.5-33.5 0-18.502-14.998-33.5-33.5-33.5C15.499.308.5 15.306.5 33.808c0 18.501 14.999 33.5 33.5 33.5",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00AC75",
    d: "m33.142 46.842 20.1-20.1a3.364 3.364 0 1 0-4.757-4.757L30.764 39.74 19.742 28.685a3.364 3.364 0 0 0-4.757 4.757l13.4 13.4a3.35 3.35 0 0 0 4.757 0"
  })));
};
export default SvgConfirmTicked;